import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    marginTop: 40,
  },
  title: {
    fontSize: 16,
    lineHeight: 19,
    color: 'black',
    fontFamily: 'TCCC-UnityText Bold',
    marginBottom: 30,
  },
  image: {
    alignSelf: 'center',
    height: 120,
    width: 120,
    borderRadius: 500,
  },
  imageSize: {
    textAlign: 'center',
    alignSelf: 'center',
    maxWidth: 250,
    color: Colors.GrayPallete.lightgrayThree,
    fontFamily: 'TCCC-UnityHeadline Regular',
    marginTop: 20,
  },
  containerButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    marginTop: 30,
  },
  containerInput: {
    paddingHorizontal: 40,
    marginTop: 70,
  },
});
